import Axios from 'axios'

const getDefaultState = () => {
  return {
    manual: [],
    manualLoading: false,
    manualLoaded: false,
    comments: [],
    commentsLoading: false,
    commentsLoaded: false,
    currentCompetence: null
  }
}

const state = getDefaultState()

const getters = {
  countCheckedFromManual: state => {
    return state.manual.filter(x => x.checked).length
  },

  getComment: state => competenceId => {
    const index = state.comments
      .findIndex(x => x.competence_id == competenceId)

    if (index !== -1) {
      return state.comments[index].comment
    } else {
      return ''
    }
  },

  getCommentIdByCompetence: state => competenceId => {
    const index = state.comments
      .findIndex(x => x.competence_id == competenceId)

    if (index !== -1) {
      return state.comments[index].id
    } else {
      return null
    }
  },

  generatedManual: state => {
    let newManual = []

    for (let i = 0; i < state.manual.length; i++) {
      const index = newManual.findIndex(x => x.title === state.manual[i].title)

    	if (index === -1) {
      	newManual.push({ title: state.manual[i].title, checkboxes: [] })
      }
    }

    for (let i = 0; i < newManual.length; i++) {
      for (let x = 0; x < state.manual.length; x++) {
        if (newManual[i].title === state.manual[x].title) {
          newManual[i].checkboxes.push(state.manual[x])
        }
      }
    }

    return newManual
  }
}

const mutations = {
  SET_MANUAL_LOADING: (state, payload) => {
    state.manualLoading = payload
  },

  SET_MANUAL_LOADED: (state, payload) => {
    state.manualLoaded = payload
  },

  SET_MANUAL: (state, payload) => {
    state.manual = payload
  },

  SET_CHECKBOX: (state, payload) => {
    const index = state.manual.findIndex(x => x.id === payload.id)

    if (index !== -1) {
      state.manual[index].checked = payload.checked
    }
  },

  SET_COMMENTS_LOADING: (state, payload) => {
    state.commentsLoading = payload
  },

  SET_COMMENTS_LOADED: (state, payload) => {
    state.commentsLoaded = payload
  },

  SET_COMMENTS: (state, payload) => {
    state.comments = payload
  },

  SET_CURRENT_COMPETENCE: (state, payload) => {
    state.currentCompetence = payload
  },
}

const actions = {
  async fetchCompetencesManual({ commit }, responseId) {
    commit('SET_MANUAL_LOADING', true)

    await Axios.get(`/1.0/spec-private/custom-process/check-manual/${responseId}`)
      .then(response => {
        const items = response.data.data
          .sort((a,b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));

        commit('SET_MANUAL', items)
        commit('SET_MANUAL_LOADED', true)
      })
      .finally(() => {
        commit('SET_MANUAL_LOADING', false)
      })
  },

  async switchCheck({ commit }, payload) {
    commit('SET_MANUAL_LOADING', true)

    const params = {
      checked: payload.checked
    }

    await Axios.put(`/1.0/spec-private/custom-process/check-manual/${payload.checkId}`, params)
      .then(() => {
        commit('SET_CHECKBOX', {
          id: payload.checkId,
          checked: payload.checked
        })
      })
      .finally(() => {
        commit('SET_MANUAL_LOADING', false)
      })
  },

  async fetchCompetencesComments({ commit }, responseId) {
    commit('SET_COMMENTS_LOADING', true)

    await Axios.get(`/1.0/spec-private/custom-process/competence-comment/${responseId}`)
      .then(response => {
        commit('SET_COMMENTS', response.data.data)
        commit('SET_COMMENTS_LOADED', true)
      })
      .finally(() => {
        commit('SET_COMMENTS_LOADING', false)
      })
  },

  async saveComment({ commit, dispatch }, payload) {
    commit('SET_COMMENTS_LOADING', true)

    const params = {
      response_id: payload.responseId,
      competence_id: payload.competenceId,
      comment: payload.comment
    }

    await Axios.put(`/1.0/spec-private/custom-process/competence-comment`, params)
      .then(() => {
        dispatch('fetchCompetencesComments', payload.responseId)
      })
      .finally(() => {
        commit('SET_COMMENTS_LOADING', false)
      })
  },

  async deleteComment({ commit, dispatch }, payload) {
    commit('SET_COMMENTS_LOADING', true)

    await Axios.delete(`/1.0/spec-private/custom-process/competence-comment/${payload.commentId}`)
      .then(() => {
        dispatch('fetchCompetencesComments', payload.responseId)
      })
      .finally(() => {
        commit('SET_COMMENTS_LOADING', false)
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
